import { ButtonProps } from '@systemeio/ui'
import React, { useState } from 'react'
import ConfirmationModal, { ConfirmationProps } from '.'

interface ConfirmationModalWithButtonProps extends Omit<ConfirmationProps, 'opened' | 'onClose'> {
  renderButton: (props: Pick<ButtonProps, 'onClick'>) => React.ReactNode
}

function ConfirmationModalWithButton({ renderButton, ...props }: ConfirmationModalWithButtonProps) {
  const [isOpened, setIsOpened] = useState<boolean>(false)
  return (
    <>
      {renderButton({ onClick: () => setIsOpened(true) })}
      <ConfirmationModal opened={isOpened} onClose={() => setIsOpened(false)} {...props} />
    </>
  )
}

export default ConfirmationModalWithButton
